enum TransferField {
  CORPS_ID,
  AMOUNT,
  BASE_CURRENCY,
  COMMENT
}
export default TransferField
